export const NAME = 'contact-file';
